





































































import { Vue, Component, Prop } from 'vue-property-decorator'
import dateShort from 'src/assets/dateShort'
import store from 'src/assets/store'
import PersonAvatar from 'components/account/PersonAvatar.vue'
import MarkdownPreviewer from 'components/MarkdownPreviewer.vue'
import TopicButtonPinned from 'src/components/presenter/item/forum/TopicButtonPinned.vue'
import TopicButtonHidden from 'src/components/presenter/item/forum/TopicButtonHidden.vue'
import TopicButtonDelete from 'src/components/presenter/item/forum/TopicButtonDelete.vue'
import TopicButtonRestore from 'src/components/presenter/item/forum/TopicButtonRestore.vue'
import TopicButtonRemove from 'src/components/presenter/item/forum/TopicButtonRemove.vue'
import { ForumTopic } from 'src/graphql/types'

@Component({
  components: {
    PersonAvatar,
    MarkdownPreviewer,
    TopicButtonPinned,
    TopicButtonHidden,
    TopicButtonDelete,
    TopicButtonRestore,
    TopicButtonRemove
  }
})
export default class ForumTopicListItem extends Vue {
  dateShort = dateShort

  @Prop()
  readonly to!: string

  @Prop({ default: false })
  readonly canEdit!: Boolean

  @Prop()
  readonly topic!: ForumTopic

  unread (topic: ForumTopic) {
    const unread = (topic.totalPosts || 0) - (topic.totalPostsPersonRead || 0)
    return unread < 100 ? unread : '99+'
  }
}
